import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useParams } from "react-router-dom";
import Spinner from "../General/Spinner";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import MyStepper from "../Jobs/Stepper";
import { runPapyrusQuery } from "../customHooks/FetchDataHook";

const PapyrusCopy = () => {
  const [useJob, setJob] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const context = useContext(AuthContext);

  useEffect(() => {
    const fetchFromPapyrus = async () => {
      try {
        setLoading(true);
        // 1. Limpiamos el ID (27650-DIG-7 -> 27650)
        const otNumber = id.split("-")[0];

        // 2. Traemos la data por NOMBRE de query. El backend arma el SQL,
        //    valida el param y habla con el bridge. El browser no ve SQL.
        const rows = await runPapyrusQuery("detalleOT", { ot: otNumber });

        if (!rows || rows.length === 0)
          throw new Error("OT no encontrada en Papyrus");

        // 3. Transformamos filas SQL en un objeto Job de Hamlet
        const jobMimetizado = transformSqlToHamlet(rows);

        setJob(jobMimetizado);
        setLoading(false);
      } catch (e) {
        setError({ message: e.response?.data?.message || e.message });
        setLoading(false);
      }
    };

    fetchFromPapyrus();
  }, [id]);

  if (loading) return <Spinner color="primary" />;
  if (error)
    return (
      <ErrorMessage
        title="Error al importar desde Papyrus"
        message={error.message}
        action={() => window.history.back()}
      />
    );

  // Al pasarle el job, el Stepper entrará en modo "Edición/Copia" automáticamente
  return <MyStepper job={useJob} />;
};

/**
 * Función que convierte el array de filas de Papyrus
 * en la estructura que espera JobsForm y JobsParts
 */
const transformSqlToHamlet = (rows) => {
  const first = rows[0];

  const otDetail = {
    Nombre: first.Nombre || first.detalle_trabajo || "Nuevo Trabajo (Papyrus)",
    Company: { Nombre: first.Company || first.cliente_nombre },
    Cantidad: first.Cantidad || 0,
    Entrega: first.entrega_fecha,
    Tipo: { name: first.tipo_producto },
    Description: first.Observacion || "",
    // Inicializamos como strings para la conciliación posterior
    Finishing: [],
    Partes: rows.reduce((acc, row) => {
      // Evitamos duplicados por las filas de entregas
      if (!acc.find((p) => p.num_parte === row.nro_parte)) {
        acc.push({
          Name: row.nombre_parte || "Parte",
          num_parte: row.nro_parte,
          Alto: row.Alto * 10,
          Ancho: row.Ancho * 10,
          Pages: row.Paginas,
          jobParts: [{ Type: row.tipo_producto }],
          partStock: `${row.papel_nombre} ${row.papel_gramaje} (${row.papel_largo}x${row.papel_ancho})`,
          ColoresFrente: row.colores_frente || 0,
          ColoresDorso: row.colores_dorso || 0,
          // Pasamos los nombres de procesos como array
          Finishing: row.procesos_lista ? row.procesos_lista.split(" | ") : [],
        });
      }
      return acc;
    }, []),
  };

  return otDetail;
};

export default PapyrusCopy;
